import { render, staticRenderFns } from "./TelegramOtpGroup.vue?vue&type=template&id=3196e88a&"
import script from "./TelegramOtpGroup.vue?vue&type=script&lang=ts&"
export * from "./TelegramOtpGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports